"use client"

import React from 'react';
import cx from "clsx";
import {Crete_Round, Fugaz_One, Noto_Sans_TC, Poppins, Rowdies} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import Footer from "@/app/(index)/footer";
import Bread from "@/app/(index)/bread";
import {Divider} from "@mantine/core";
import {useMediaQuery} from "@mantine/hooks";
import Header2 from "@/app/(index)/header2";
import MissionPC from "@/app/(index)/mission/mission-pc";
import MissionMobile from "@/app/(index)/mission/mission-mobile";

const poppins = Poppins({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});


const fugazOne = Fugaz_One({
    weight: ['400'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const creteRound = Crete_Round({
    weight: ['400'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const rowdies = Rowdies({
    weight: ['300', '400', '700'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

export default function Page() {
    const { fontSize, lang } = useGlobalStateStore();
    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }

    const mediaQueryLessSM = useMediaQuery('(min-width: 480px)');
    return (
        <div className={cx("min-h-screen flex flex-col justify-between", notoSansTC.className)}>
            <div>
                <Header2/>
                {
                    mediaQueryLessSM && (
                        <Bread name_c="關於科政中心 - 核心任務" name_e="About STPI - Mission"/>
                    )
                }
                <div className={cx("mx-auto mb-[100px]", mediaQueryLessSM ? 'w-[1250px]' : 'w-full mt-[100px] px-[10px]')}>
                    <div className="bg-[url('/images/title_topBG.png')] bg-[length:100%_5px] bg-no-repeat bg-top inline-block pt-[15px] pb-[45px] text-[#5b5b5b] text-[35px] font-bold">
                        { lang == "tw" && "核心任務" }
                        { lang == "en" && "Mission" }
                    </div>
                    {
                        lang == "tw" && (
                            <>
                                <div className="text-[20px] font-bold leading-[40px]">
                                    科技政策研究與資訊中心 Science & Technology Policy Research and Information Center,
                                    STPI <br/>成立於1974年，是我國學研機構倚重的科技資訊服務單位。
                                </div>
                                <div className="text-[20px] leading-[40px]">
                                    2005年改制為財團法人後，除持續強化學術研究資訊服務基礎環境外，並積極發展科技資訊分析能力，建立科技政策研究的能量，以支援政府科技政策決策，目前已成為我國科技政策幕僚與資訊服務單位，肩負「國家級科技智庫」角色。科政中心以成為具備學術基礎和實證研究特色的世界級科技政策智庫為發展目標，結合學者專家整合建立科技政策研究體系，建構科技研究方法與知識庫，提供科技政策形成機制與溝通平台，以促進台灣科技政策決策體系專業化與健全化之發展，加速我國科技整體發展與提升國際競爭力。
                                </div>

                                <Divider color="#cedbdc" mt={50} mb={40}/>
                                <div className="text-[30px] text-black font-bold">
                                    {lang == "tw" ? "主要任務" : "Main Missions"}
                                </div>
                            </>
                        )
                    }
                    {
                        mediaQueryLessSM ? (
                            <MissionPC/>
                        ) : (
                            <MissionMobile />
                        )
                    }
                </div>
            </div>
            <Footer/>
        </div>
    );
}
